import React, { useEffect, useState, useContext } from 'react';
import eventManager from '@alife/scc-event-manager/event-manager';
import safeLog from '@alife/bc-safe-log';
import { Button } from '@alifd/next';
import fetchJsonp from 'fetch-jsonp';
import getValue from './getValue';
import ContextManager from './context-manager';

require('es6-promise').polyfill();

export default function SkuPayment() {
  // 更新物流
  const [data, setData] = useState({});
  const [country, setCountry] = useState(null);

  // 更新表单数据
  const [formData, setFormData] = useState('');
  // 更新价格数据
  const [number, setNumber] = useState(0);
  const [price, setPrice] = useState(null);

  const { postData, I18n, setTipShow, productId } = useContext(ContextManager);
  // 所有SKU
  const { skus } = postData;

  // 货币
  const productPriceCurrencySimpleName = '$ ';
  // 获取港口信息
  const inventoryData = getValue('inventoryData') || {};

  const handleLogisticsChange = data => {
    setCountry(data.fullCountry);
    setData({
      method: data.logisticsMethod,
      cost: data.logisticsCost.replace(/[^\d.]+/g, ''),
    });
  };

  const getExpress = async (data = {}) => {
    if (document.getElementsByClassName('logistics-method').length === 0)
      return;
    const result = await fetchJsonp(
      `//scm.alibaba.com/freight/listFreightCostForDetail.jsonp?json=${JSON.stringify(
        Object.assign(
          {
            pid: productId,
            quantity: 1,
            terminal: 'PC',
            dispatchLocation: inventoryData.defaultDispatchId,
            country: 'US',
          },
          data,
        ),
      )}`,
    ).then(response => response.json());
    if (result.data && result.data.data && result.data.data.length > 0) {
      setCountry(result.data.fullCountry);
      setData(result.data.data[0]);
    }
  };

  useEffect(() => {
    if (document.getElementsByClassName('logistics-method').length === 1) {
      getExpress();
      eventManager.on('logisticsChange', handleLogisticsChange);
    }
  }, []);

  const handleExpress = () => {
    document.getElementsByClassName('logistics-method')[0].click();
  };

  // 更新价格
  const getSkuInfo = () => {
    const skuList = Object.values(skus).filter(i => i.number > 0);
    if (skuList.length > 0) {
      const totalPrice = skuList.map(i => i.total).reduce((a, b) => a + b);
      const totalNumber = skuList.map(i => i.number).reduce((a, b) => a + b);
      setNumber(totalNumber);
      setPrice(totalPrice);

      // 更新下单参数
      const data = [];
      skuList.forEach(item => {
        data.push({
          productId,
          dispatchLocation: inventoryData.defaultDispatchId || 'CN',
          skuId: item.skuId,
          quantity: item.number || '',
        });
      });

      setFormData(JSON.stringify(data));
      // 是否提示信息
      setTipShow(false);

      const skuQuantity = {};
      skuList.forEach(i => {
        skuQuantity[i.skuId] = i.number;
      });
      // 更新物流数据
      getExpress({
        quantity: totalNumber,
        skuQuantity,
        productTotalPrice: totalPrice,
      });
    } else {
      setNumber(0);
      setPrice(null);
    }
  };

  const handleSubmit = e => {
    if (number === 0) {
      e.preventDefault();
      setTipShow(true);
      safeLog(
        '/sc.details.getSample',
        'CLK',
        `from=opensku&type=tips&pid=${productId}`,
        'GET',
      );
    }

    safeLog(
      '/sc.details.getSample',
      'CLK',
      `from=opensku&type=submit&pid=${productId}`,
      'GET',
    );
  };

  useEffect(() => {
    getSkuInfo();
  }, [postData]);

  return (
    <div className="sku-payment">
      <form
        onSubmit={handleSubmit}
        action="//biz.alibaba.com/contract/SampleOrder.htm?tracelog=from_detail_get_sample"
        method="post"
      >
        <input type="hidden" name="data" value={formData} />
        <div className="payment-title">{I18n.get('amount')}</div>
        {number > 0 && (
          <div className="payment-ship">
            <div className="ship-left">
              <div className="ship-item">
                <strong>{number} </strong>
                <span> items</span>
              </div>
            </div>
            <div className="ship-right">
              {productPriceCurrencySimpleName} {price}
            </div>
          </div>
        )}
        {data && data.cost && (
          <div className="payment-ship">
            <div className="ship-left">
              <div className="ship-item">
                <span>{I18n.get('shipto')}</span>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    handleExpress();
                  }}
                >
                  {country}
                </a>
              </div>
              {data && data.method && (
                <div className="ship-item">
                  <span>by</span>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      handleExpress();
                    }}
                  >
                    {data.method}
                  </a>
                </div>
              )}
            </div>
            <div className="ship-right">
              {productPriceCurrencySimpleName} {data.cost || 0}
            </div>
          </div>
        )}
        {data && data.time && (
          <div className="payment-days">
            {I18n.get('shipto')} <strong>{data.time}</strong> {I18n.get('days')}
          </div>
        )}
        {number > 0 && data && (
          <div className="payment-total">
            <div className="total-left">{I18n.get('total')}</div>
            <div className="total-right">
              {productPriceCurrencySimpleName}{' '}
              {Math.floor((price + parseFloat(data.cost || 0)) * 100) / 100}
            </div>
          </div>
        )}
        <div className="payment-button">
          <Button type="primary" htmlType="submit">
            {I18n.get('buySample')}
          </Button>
        </div>
      </form>
    </div>
  );
}
